import { useState, useEffect } from 'react';

export const useMatchmakingTimer = (
	isMatchmakingActive: boolean,
	initialTime: number,
	storageKey?: string
) => {
	const [timeLeft, setTimeLeft] = useState(() => {
		if (!storageKey) return initialTime;
		const key = `timer_${storageKey}`;
		const expiry = localStorage.getItem(key);
		if (expiry) {
			const remaining = Math.max(0, Math.floor((Number(expiry) - Date.now()) / 1000));
			if (remaining > 0) return remaining;
		}
		return initialTime;
	});

	useEffect(() => {
		const key = storageKey ? `timer_${storageKey}` : null;

		if (!isMatchmakingActive) {
			if (key) localStorage.removeItem(key);
			setTimeLeft(initialTime);
			return;
		}

		let expiry = key ? Number(localStorage.getItem(key)) : null;

		if (!expiry || isNaN(expiry)) {
			expiry = Date.now() + initialTime * 1000;
			if (key) localStorage.setItem(key, String(expiry));
		}

		const updateTimer = () => {
			const now = Date.now();
			const remaining = Math.max(0, Math.floor((expiry! - now) / 1000));
			setTimeLeft(remaining);

			if (remaining === 0) {
				if (key) localStorage.removeItem(key);
				clearInterval(interval);
			}
		};

		// Initial update
		updateTimer();

		const interval = setInterval(updateTimer, 1000);

		return () => clearInterval(interval);
	}, [isMatchmakingActive, initialTime, storageKey]);

	return {
		timeLeft,
		setTimeLeft,
	};
};
